import React, { Component } from 'react';
import {
    FormGroup,
    Input,
    Label,
    Row,
    Col,
} from 'reactstrap';

class SearchForm extends Component {

    render() {
        return (
            <>
                {/* <Card className="text-left mt-0 mb-2">
                    <CardBody> */}
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <Label>Company Name</Label>
                            <Input
                                type="text"
                                name="name"
                                onChange={e => this.props.handleTextInputChange(e, false)}
                                onKeyPress={e => this.props.handleKeyUp(e)}
                                value={this.props.groupSelections.name}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <Label>SEC Number</Label>
                            <Input
                                type="text"
                                name="sec_number"
                                onChange={e => this.props.handleTextInputChange(e, false)}
                                onKeyPress={e => this.props.handleKeyUp(e)}
                                value={this.props.groupSelections.sec_number}
                            />
                        </FormGroup>
                    </Col>
                    {/* <Col md={4}>
                        <FormGroup>
                            <Label>Type</Label>
                            <Input
                                type="select"
                                name="attribute_value"
                                onChange={e => this.props.handleTextInputChange(e, false)}
                                value={this.props.groupSelections.attribute_value}
                            >
                                <option value="">SELECT</option>
                                <option>Customer</option>
                                <option>Prospect</option>
                                <option>Vendor</option>
                            </Input>
                        </FormGroup>
                    </Col> */}
                </Row>
                <Row>
                    <Col>
                        <FormGroup>
                            <Label>City</Label>
                            <Input
                                type="text"
                                name="city"
                                onChange={e => this.props.handleTextInputChange(e, false)}
                                onKeyPress={e => this.props.handleKeyUp(e)}
                                value={this.props.groupSelections.city}
                            />
                        </FormGroup>
                    </Col>

                    <Col>
                        <FormGroup>
                            <Label>State</Label>
                            <Input
                                type="select"
                                name="state"
                                onChange={e => this.props.handleStateInputChange(e)}
                                value={this.props.groupSelections.state}
                            >
                                {this.props.usStates.map(d => (
                                    <option value={d.abbr} key={'us_state_' + d.state} >{d.state}</option>
                                ))}
                            </Input>
                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup>
                            <Label>Zip</Label>
                            <Input
                                type="text"
                                name="zip"
                                onChange={e => this.props.handleTextInputChange(e, false)}
                                onKeyPress={e => this.props.handleKeyUp(e)}
                                value={this.props.groupSelections.zip}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup>
                            <Label>Website</Label>
                            <Input
                                type="text"
                                name="website"
                                onChange={e => this.props.handleTextInputChange(e, false)}
                                onKeyPress={e => this.props.handleKeyUp(e)}
                                value={this.props.groupSelections.website}
                            />
                        </FormGroup>
                    </Col>

                </Row>
                {/* </CardBody>
                </Card> */}
            </>
        );
    }
}

export default SearchForm;